// extracted by mini-css-extract-plugin
export var Bullet = "styles-module--Bullet--qDyxw";
export var ExpandIcon = "styles-module--ExpandIcon--4JCSn";
export var FAQAnswerMobile = "styles-module--FAQAnswerMobile--U+iQj";
export var FAQItem = "styles-module--FAQItem--GmznG";
export var FAQLeft = "styles-module--FAQLeft--pHDOG";
export var FAQRight = "styles-module--FAQRight--2PALP";
export var Puck = "styles-module--Puck--pmrj1";
export var isActive = "styles-module--isActive--YFD47";